import React, { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

const SwUpdateBanner: React.FC = () => {
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(
    null,
  );

  useEffect(() => {
    const handleUpdate = (event: Event) => {
      const registration = (event as CustomEvent<ServiceWorkerRegistration>)
        .detail;
      if (registration.waiting) {
        setWaitingWorker(registration.waiting);
      }
    };

    window.addEventListener("swUpdateAvailable", handleUpdate);
    return () => window.removeEventListener("swUpdateAvailable", handleUpdate);
  }, []);

  const handleUpdate = () => {
    if (!waitingWorker) return;

    setWaitingWorker(null);

    navigator.serviceWorker.addEventListener(
      "controllerchange",
      () => {
        window.location.reload();
      },
      { once: true },
    );

    waitingWorker.postMessage({ type: "SKIP_WAITING" });
  };

  if (!waitingWorker) return null;

  return (
    <div
      className="fixed left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 bg-slate-800 text-white px-4 py-3 rounded-2xl shadow-2xl border border-slate-700 max-w-xs w-[calc(100%-2rem)]"
      style={{ top: "calc(env(safe-area-inset-top) + 1rem)" }}
    >
      <RefreshCw size={16} className="shrink-0 text-blue-400" />
      <p className="text-xs font-semibold flex-1 leading-relaxed">
        新しいバージョンがあります
      </p>
      <button
        onClick={handleUpdate}
        className="shrink-0 bg-blue-500 hover:bg-blue-400 active:scale-95 transition-all text-white text-xs font-bold px-3 py-1.5 rounded-lg"
      >
        今すぐ更新
      </button>
    </div>
  );
};

export default SwUpdateBanner;
